import { Box, Text } from '@wegroup/design-system';
import React from 'react';
import styled, { css } from 'styled-components';
import { LouiseQuote } from '../../../../../../../../types/Quotes';

// Components
import BorderWrapper from './BorderWrapper';

interface Props {
  quotes: LouiseQuote[];
  withBackground?: boolean;
}

const ComparisonMatrixTitle: React.FC<React.PropsWithChildren<Props>> = ({
  quotes,
  children,
  withBackground,
}) => {
  return (
    <>
      <Text
        textStyle="h5Headline"
        w="100%"
        background={withBackground ? 'gray.ultraLight' : 'transparent'}
        py="4"
        px="6"
        borderTopLeftRadius="md"
      >
        {children}
      </Text>
      {quotes.map(({ id, bestOffer }) => (
        <StyledDesktopBorderWrapper
          key={`border_wrapper_${id}`}
          withBackground={withBackground}
          bestOffer={bestOffer}
        />
      ))}
      <Box
        w="50%"
        background={withBackground ? 'gray.ultraLight' : 'transparent'}
        borderTopRightRadius="md"
      />
    </>
  );
};

const StyledDesktopBorderWrapper = styled(BorderWrapper)<{
  withBackground?: boolean;
  bestOffer?: boolean;
}>`
  background: ${({ withBackground }) =>
    withBackground ? '#f7f8fb' : 'transparent'};

  ${({ bestOffer }) =>
    bestOffer &&
    css`
      > div {
        border-left: 1px solid ${({ theme }) => theme.primary[500]};
        border-right: 1px solid ${({ theme }) => theme.primary[500]};
      }
    `}
`;

export default ComparisonMatrixTitle;
